module.exports = __webpack_public_path__ + "img/17.88d01e2f.svg";